module.exports = __webpack_public_path__ + "static/img/xbanner.021f622.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Profile/images/xbanner.png
// module id = Y3xx
// module chunks = 169